import {ICustomerAddress, IShippingAddress} from "../types/types";

export default function formatAddress(address: IShippingAddress | ICustomerAddress) : string {
  return `${address.firstName} ${address.lastName}, ${address.address1}, ${address.city}, ${address.province}, ${address.country}, ${address.zip}`;
}
